// Phase 40 Plan 02 Task 2 — SyncedToast.
// CONTEXT D-16. UI-SPEC §4.
//
// Auto-dismissing top toast surfaced after first-sign-in upload succeeds.
// Plays a brief fade + 8px-down entrance via inline keyframes; the toast
// auto-dismisses after 4 seconds via the parent (AuthProvider sets visible
// → false on a setTimeout). Falls back to a static appearance under
// prefers-reduced-motion.

import React, { useEffect } from 'react';
import { CheckCircle2 } from 'lucide-react';

export default function SyncedToast({ onDismiss }) {
  useEffect(() => {
    if (!onDismiss) return undefined;
    const t = setTimeout(onDismiss, 4000);
    return () => clearTimeout(t);
  }, [onDismiss]);

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        // Respect Dynamic Island / status-bar inset. Preserve the original
        // 12px breathing room on devices with no inset (desktop / older iOS).
        top: 'calc(12px + env(safe-area-inset-top, 0px))',
        left: 16,
        right: 16,
        margin: '0 auto',
        maxWidth: 400,
        background: 'var(--c-tint)',
        borderLeft: '3px solid var(--c-success)',
        borderRadius: 'var(--radius-md, 12px)',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        zIndex: 3000,
        animation: 'tendToastIn 280ms cubic-bezier(0.4,0,0.2,1)',
        fontFamily: 'Lora, serif',
      }}
    >
      <CheckCircle2 size={20} stroke="var(--c-success)" aria-hidden="true" />
      <small style={{ fontSize: '0.9375rem', color: 'var(--c-text)', lineHeight: 1.55 }}>
        Synced. Your garden is now backed up.
      </small>
      <style>{`
        @keyframes tendToastIn {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @media (prefers-reduced-motion: reduce) {
          [role="status"] { animation: none !important; }
        }
      `}</style>
    </div>
  );
}
